import {MultiSelectTheme} from 'chakra-multiselect';

const baseStyle = (props) => {
    const multiSelectBaseStyle = MultiSelectTheme.baseStyle(props);

    return {
        ...multiSelectBaseStyle,
        actionGroup: {
            marginLeft: 0,
        },
        button: {
            ...multiSelectBaseStyle.button,
            border: 'none',
            color: 'gray.dark',
            _active: {
                backgroundColor: 'transparent',
            },
            _hover: {
                color: 'primary.default',
                backgroundColor: 'transparent',
            },
            _focus: {
                color: 'primary.default',
                backgroundColor: 'transparent',
            },
            _selected: {
                backgroundColor: 'transparent',
            },
        },
        control: {
            border: '1px solid',
            borderColor: 'gray.200',
            borderRadius: 'md',
            paddingX: 3,
            paddingY: 2,
            height: '100%',
            minHeight: 10,
            _hover: {borderColor: 'gray.300'},
            _disabled: {
                backgroundColor: 'gray.50',
                opacity: 1,
                cursor: 'not-allowed',
            },
            _invalid: {
                borderColor: 'error',
                _focus: {
                    borderColor: 'error',
                },
            },
            sx: {
                '&:focus-within': {
                    zIndex: 1,
                    borderColor: 'primary.default',
                },
                '&:focus-within:hover': {
                    borderColor: 'primary.700',
                },
            },
        },
        input: {
            ...multiSelectBaseStyle.input,
            appearance: 'none',
            _placeholder: {
                color: 'text.secondary.light',
            },
        },
        label: {
            fontSize: 'xs',
            fontWeight: 'semibold',
            color: 'text.secondary.light',
            lineHeight: '1.5',
            marginBottom: 1,
        },
        list: {
            ...multiSelectBaseStyle.list,
            zIndex: 'layer2',
        },
        selectedList: {
            ...multiSelectBaseStyle.selectedList,
            gap: 1,
        },
        selectedItem: {
            ...multiSelectBaseStyle.selectedItem,
            background: 'navBlue',
            paddingX: 2.5,
            paddingY: 'px',
            borderRadius: 'full',
            border: 'none',
            borderColor: 'transparent',
            _hover: {
                background: 'gray.300',
            },
            _focusWithin: {
                outline: '1px solid',
                outlineColor: 'gray.400',
            },
            sx: {
                '&>button': {
                    width: 4,
                    height: 4,
                    marginLeft: 1,
                },
                '&>button>svg': {
                    height: 3,
                    width: 3,
                },
                '&>span': {
                    lineHeight: '1.5',
                    maxWidth: 36,
                    isTruncated: true,
                },
            },
        },
    };
};

const sizes = {
    ...MultiSelectTheme.sizes,
    sm: {
        ...MultiSelectTheme.sizes.sm,
        control: {
            minH: 10,
            spacing: 1,
        },
        input: {
            ...MultiSelectTheme.sizes.sm.input,
            fontSize: {base: 'base', desktop: 'sm'},
            height: 6,
        },
        selectedItem: {
            m: 0,
        },
    },
};

const multiSelectTheme = {
    ...MultiSelectTheme,
    baseStyle,
    sizes,
};

export default multiSelectTheme;
